import Link from '@material-ui/core/Link'
import { Text } from 'shared/components/Text/Text'
import { lightGray1, midGray } from 'shared/theme/colors'
import { css, styled } from 'styled-components'

import { isConsole } from '../../../config/config'
import { formatReadableDate } from '../../../helpers/dateHelpers'
import { formatCurrency } from '../../../helpers/formatters'
import { Handler } from '../../../helpers/typeHelper'
import { useBreakpoint } from '../../../hooks/useBreakpoint'
import { Repayment, RepaymentHistoryItem, RepaymentPolicyStatus } from '../../../models/repayments'
import { breakpoints } from '../../../theme/breakpoints'
import { Grid } from '../../Base/Grid'
import { getPolicyStatus } from '../Policy.helper'
import { POLICY_DETAIL_CARD_HORIZONTAL_PADDING } from './PolicyDetailCard'

interface PolicyDetailHistoryProps {
  policy: Repayment
}

export function PolicyDetailHistory({ policy }: PolicyDetailHistoryProps) {
  const status = getPolicyStatus(policy)

  return (
    <>
      <Text variant="uppercaseLabel2" color={midGray} mb={2}>
        Payment History
      </Text>

      {status === RepaymentPolicyStatus.DRAFT || !policy.repayment_history?.length ? (
        <Text variant="header3" color={lightGray1} mb={2}>
          No payment history
        </Text>
      ) : (
        <>
          {policy.repayment_history.map((item) => (
            <PolicyTableRow key={item.statement_id}>
              <Text variant="label2" color={midGray}>
                {formatReadableDate(item.payment_date, { monthShort: true })}
              </Text>

              <Text variant="label2" color={midGray} align="left">
                <RowType item={item} />
              </Text>

              <Text variant="header3" color={midGray}>
                -{formatCurrency(item.payment_amount)}
              </Text>
            </PolicyTableRow>
          ))}
        </>
      )}
    </>
  )
}

function RowType({ item }: { item: RepaymentHistoryItem }) {
  if (isConsole() && item.job_id)
    return (
      <Link
        href={`/jobs/${item.job_id}/show/`}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: 'none' }}
      >
        {item.payment_note || item.job_human_id || 'Non-Job Payment'}
      </Link>
    )
  return <>{item.payment_note || item.job_human_id || 'Non-Job Payment'}</>
}

export function PolicyTableRow({
  children,
  isHeader,
  onClick,
}: {
  children: React.ReactNode
  isHeader?: boolean
  onClick?: Handler
}) {
  const isSm = useBreakpoint('sm')

  function getColumns() {
    if (isSm) return 'auto 1fr auto'
    return '250px 1fr auto'
  }

  return (
    <StyledGrid columns={getColumns()} gap="10px" $isHeader={isHeader} onClick={onClick}>
      {children}
    </StyledGrid>
  )
}

const StyledGrid = styled(Grid)<{ $isHeader?: boolean }>`
  margin-top: 8px;
  border-top: 1px solid rgba(199, 209, 218, 0.5);
  margin: 0 -${POLICY_DETAIL_CARD_HORIZONTAL_PADDING}px;
  padding: 14px ${POLICY_DETAIL_CARD_HORIZONTAL_PADDING}px 12px;

  @media ${breakpoints.sm} {
    margin: 0 -20px;
  }

  ${(p) =>
    p.$isHeader &&
    css`
      padding-top: 5px;
      border-top: none;
    `}
`
